<template>
    <div class="tab-pane active p-20">
        <div v-if="tenant.stripeStatus">
            <PmlSubscription></PmlSubscription>
            <hr>
            <PmlCreditCard ref="creditCardComponent"></PmlCreditCard>
        </div>
        <div v-if="tenant.stripeStatus == 'trialing'">
            <PmlSubscribe @cardRefresh="cardRefresh"></PmlSubscribe>
        </div>
    </div>
</template>

<script>
    import PmlCreditCard from './credit-card/Main.vue'
    import PmlSubscription from './subscriptions/Current.vue'
    import PmlSubscribe from './subscriptions/New.vue'
    import { mapGetters } from 'vuex'
    import { trans } from 'utils/helpers/translation'

    export default {
        name: 'Billing',
        data () {
            return {
                errors: [],
                paymentMethods: [],
                subscriptions: []
            }
        },
        metaInfo () {
            return {
                title: this.company.fancy_name + ' | ' + trans('subscription')
            }
        },
        components: {
            PmlCreditCard,
            PmlSubscription,
            PmlSubscribe
        },
        computed: {
            ...mapGetters({
                'tenant': 'getTenant',
                'company': 'getCompany'
            }),
            records () {
                return this.members || []
            }
        },
        methods: {
            cardRefresh () {
                this.$refs.creditCardComponent.cardRefresh()
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/company/components/billing/Main.vue